module.exports = __webpack_public_path__ + "static/media/HAUX_MAIS_VIDA_9.0cd83dce.pdf";